<template>
  <div
    class="kt-portlet votd-container position-relative"
    id="video-of-the-day"
  >
    <visibility-checkbox type="featuredVideo" />
    <div class="kt-portlet__body">
      <div class="kt-portlet__content text-right votd-heading">
        <div style="text-align: right">
          <v-toolbar flat color="#e3e8ef">
            <h3>{{ componentTitle }}</h3>
            <v-spacer></v-spacer>
            <v-btn
              v-if="isSuperAdmin || isAccountManager"
              @click="addItem()"
              text
              color="primary"
            >
              <i class="fal fa-upload mr-1" />
              Update Video
            </v-btn>
          </v-toolbar>

          <v-dialog v-model="videoForm" max-width="500px" persistent scrollable>
            <v-card>
              <v-card-title>
                <span class="headline">Add new video</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <form class="kt-form">
                    <div class="form-group">
                      <label>Video Type</label>
                      <div class="d-flex w-100">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <label class="radio col-6" v-bind="attrs" v-on="on">
                              <input
                                v-model="type"
                                type="radio"
                                id="video-day"
                                value="1"
                                name="radio-group"
                                checked
                              />
                              <span></span>
                              Video of the day
                            </label>
                          </template>
                          <span>Daily new videos to help your team grow</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <label class="radio col-6" v-bind="attrs" v-on="on">
                              <input
                                v-model="type"
                                type="radio"
                                id="featured"
                                value="2"
                                name="radio-group"
                                checked
                              />
                              <span></span>
                              Featured
                            </label>
                          </template>
                          <span
                            >Video that will constantly appear on your site
                            until it reaches its expiration date or you change
                            it manually</span
                          >
                        </v-tooltip>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Title of the Video"
                        v-model="name"
                        required
                        v-validate="'required'"
                        name="name"
                      />
                      <span class="kt-font-danger validate-error">
                        {{ errors.first('name') }}
                      </span>
                    </div>
                    <div class="form-group">
                      <v-switch
                        v-model="fileUploadOrLink"
                        label="Video Upload"
                      ></v-switch>
                    </div>
                    <div class="form-group" v-if="!fileUploadOrLink">
                      <label>Video URL</label>
                      <input
                        @input="fetchVideoId"
                        type="url"
                        class="form-control"
                        placeholder="Enter Video URL"
                        v-model="videoUrl"
                        required
                        v-validate="'required|url'"
                        name="url"
                      />
                      <span
                        class="kt-font-danger validate-error"
                        v-show="errors.has('url')"
                      >
                        {{ errors.first('url') }}
                      </span>
                    </div>
                    <div class="form-group" v-if="fileUploadOrLink">
                      <v-file-input
                        v-model="videoFile"
                        v-validate="'required'"
                        accept="video/*"
                      >
                      </v-file-input>
                      <span
                        class="kt-font-danger validate-error"
                        v-show="errors.has('image')"
                        >{{ errors.first('image') }}</span
                      >
                    </div>

                    <template v-if="type === '1'">
                      <div class="form-group">
                        <label>Start Date and Time</label>
                        <flat-pickr
                          :config="configs.dateTimePicker"
                          id="datetime-input"
                          class="form-control"
                          v-model="startDate"
                          placeholder="Date Time"
                          v-validate="'required'"
                          data-vv-name="startDate"
                        />
                      </div>

                      <div class="form-group" v-if="type === '2'">
                        <v-checkbox
                          v-model="expiration"
                          label="No Expiry"
                          color="indigo"
                          hide-details
                        />
                      </div>

                      <div
                        class="form-group"
                        v-if="
                          (expiration === false && type === '2') || type === '1'
                        "
                      >
                        <label>End Date and Time</label>
                        <flat-pickr
                          :config="configs.dateTimePicker"
                          id="datetime-input"
                          class="form-control"
                          v-model="endDate"
                          placeholder="Date Time"
                          v-validate="'required'"
                          data-vv-name="endDate"
                        />
                      </div>
                    </template>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        class="ml-2"
                        color="#ff5252"
                        dark
                        @click="close"
                        small
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        class="ml-2"
                        :loading="isLoading"
                        @click="reset"
                        small
                      >
                        Reset
                      </v-btn>
                      <v-btn
                        color="blue darken-2"
                        dark
                        :loading="isLoading"
                        @click="save"
                        small
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <date-picker
          :dialog="datePickerDialog"
          :datePickerType="datePickerType"
          :toggleDatePickerDialog="toggleDatePickerDialog"
          :saveDatePicker="saveDatePicker"
          :startDate="startDate"
          :endDate="endDate"
        />
        <div>
          <hr />
        </div>
        <div v-show="isFetchingVoTD">
          <vue-content-loader
            :width="994"
            :height="559"
            :speed="2"
            primaryColor="#e4e2e2"
            secondaryColor="#ecebeb"
          >
            <rect x="0" y="0" rx="0" ry="0" width="994" height="559" />
          </vue-content-loader>
        </div>
        <div v-show="!isFetchingVoTD">
          <div
            id="votd-cont"
            class="embed-responsive embed-responsive-16by9 mb-3 video-container"
            v-if="FeaturedVideo"
          >
            <div v-show="!isYoutube">
              <iframe
                title=""
                id="votd-vimeo"
                class="embed-responsive-item"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                :src="FeaturedVideo.url"
                v-show="!isYoutube"
              ></iframe>
            </div>
            <div v-show="isYoutube">
              <div id="player"></div>
            </div>
          </div>

          <v-container v-else>
            <v-card-text class="text-center">
              No Featured Video Available
            </v-card-text>
          </v-container>
        </div>
        <v-spacer></v-spacer>
        <v-btn text color="primary" target="_blank" to="/recent-videos">
          <v-icon class="mr-2" small>fal fa-arrow-right</v-icon>
          Recent Videos
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { map as _map, some as _some } from 'lodash-es';
import VueContentLoader from 'vue-content-loading';
import DatePicker from '../../dashboard/DatePicker.vue';
import EventBus from '../../../plugins/eventBus';
import VisibilityCheckbox from '../VisibilityCheckbox';

export default {
  name: 'FeaturedVideo',
  components: {
    VisibilityCheckbox,
    VueContentLoader,
    DatePicker,
  },
  data() {
    return {
      isLoading: false,
      isFetchingVoTD: false,
      loading: false,
      FeaturedVideo: {},
      isWatched: false,
      isWatchedLoading: false,
      played: false,

      id: '',
      name: '',
      videoUrl: '',
      startDate: null,
      expiration: true,
      endDate: null,
      relatedUnits: [],
      type: '1',
      videoType: 0, //0 VIMEO | 1 YOUTUBE
      selectedVideoType: 0,

      datePickerType: '',
      datePickerDialog: false,
      videoForm: false,

      fileUploadOrLink: false,
      videoFile: [],

      configs: {
        dateTimePicker: {
          enableTime: true,
          dateFormat: 'm/d/Y G:i K',
        },
      },
      debounce: null,
      youtube_id: null,

      player: null,
    };
  },
  computed: {
    isYoutube() {
      return this.selectedVideoType == 1;
    },
    isVimeo() {
      return this.selectedVideoType == 0;
    },
    componentTitle() {
      return this.FeaturedVideo.type === 1
        ? 'Video of the Day'
        : 'Featured Video';
    },
    startDateFormatted() {
      if (this.startDate === null) {
        return null;
      }

      return dayjs(this.startDate).format('ddd, MMM D, YYYY H:mm A');
    },
    endDateFormatted() {
      if (this.endDate === null) {
        return null;
      }

      return dayjs(this.endDate).format('ddd, MMM D, YYYY H:mm A');
    },
    roles() {
      return this.$auth.user().roles;
    },
    isSuperAdmin() {
      return _some(this.roles, { name: 'super-administrator' });
    },
    isAccountManager() {
      return _some(this.roles, { name: 'account-manager' });
    },
  },

  mounted() {
    this.$validator.localize('en', {
      attributes: {
        name: 'name',
        videoUrl: 'video url',
      },
    });
    EventBus.$on('refreshFeaturedVideo', () => {
      this.getLatestVideo();
    });
  },

  methods: {
    loadYoutube(id = null, maxTry = 0) {
      try {
        this.player = new YT.Player('player', {
          height: '390',
          width: '640',
          videoId: id,
          autoplay: '0',
          playerVars: {
            playsinline: 1,
          },
          events: {
            onStateChange: this.onPlayerStateChange,
          },
        });
      } catch (e) {
        this.loadYoutube(id);
      }
    },
    onPlayerStateChange(event) {
      let status = event.target.getPlayerState();
      const vm = this;

      // -1 – unstarted
      // 0 – ended
      // 1 – playing
      // 2 – paused
      // 3 – buffering
      // 5 – video cued

      if (status == 1) vm.processPlayedVideo();
      else if (status == 0) vm.markAsCompleted();
    },
    addItem() {
      this.videoForm = true;
    },
    resetTime() {
      this.startDate = null;
      this.endDate = null;
    },
    reset() {
      this.id = '';
      this.name = '';
      this.videoUrl = '';
      this.startDate = null;
      this.expiration = true;
      this.endDate = null;
      this.relatedUnits = [];
      this.type = '1';
      this.errors.clear();
      this.$validator.reset();
    },
    close() {
      this.videoForm = false;
      this.reset();
    },
    toggleDatePickerDialog() {
      this.datePickerDialog = !this.datePickerDialog;
    },
    openDatePicker(type) {
      this.toggleDatePickerDialog();
      this.datePickerType = type;
    },
    saveDatePicker(val) {
      if (this.datePickerType === 'startDate') {
        return (this.startDate = val);
      }
      return (this.endDate = val);
    },
    save() {
      this.isLoading = true;
      this.$validator
        .validate('*')
        .then((result) => {
          if (result) {
            return this.send();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setFormData() {
      const relatedUnits = _map(this.relatedUnit, (unit) => unit.id);
      const formData = new FormData();
      formData.append('name', this.name);
      formData.append('videoUrl', this.youtube_id);
      formData.append(
        'startDate',
        this.startDate
          ? dayjs(this.startDate).format('YYYY-MM-DD HH:mm:ss')
          : null
      );
      formData.append(
        'endDate',
        this.type === '2'
          ? this.expiration
            ? null
            : dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss')
          : dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss')
      );

      formData.append('videoType', this.videoType);
      formData.append('expiration', this.type == '2' ? this.expiration : false);
      formData.append('type', this.type);
      formData.append('fileUploadOrLink', this.fileUploadOrLink);
      formData.append('videoFile', this.videoFile);
      formData.append('relatedUnits', relatedUnits);

      return formData;
    },
    send() {
      this.isLoading = true;
      if (this.isYoutube) this.player.stopVideo();

      this.$store
        .dispatch('videosDaily/addVideo', this.setFormData())
        .then(() => {
          this.$store.dispatch('videosDaily/getVideos', 1);
          this.$notify('success', 'Daily video added', true);
          this.close();
          EventBus.$emit('refreshFeaturedVideo');

          this.isLoading = false;
        })
        .catch((errors) => {
          this.interactWithErrorBag(errors, this.errors);
        });
    },
    getLatestVideo() {
      this.isFetchingVoTD = true;
      this.axios
        .get('get-featured-video')
        .then(({ data }) => {
          this.FeaturedVideo = data;
          this.fetchIsWatched(data.id);

          let youtube = this.youtubeParser(data.url);

          if (!youtube) {
            this.selectedVideoType = 0;
          } else {
            if (this.player == null) {
              this.loadYoutube(youtube);
            } else {
              this.player.loadVideoById(youtube, 0);
              this.player.stopVideo();
            }

            this.selectedVideoType = 1;
          }
        })
        .finally(() => {
          this.isFetchingVoTD = false;
          this.loadVimeoPlayerSettings();
        });
    },
    fetchIsWatched(id) {
      this.axios.get(`/featured-video-watched/${id}`).then(({ data }) => {
        if (data.watched) {
          this.isWatched = data.watched.watched;
          this.played = data.watched.played;
        } else {
          this.isWatched = false;
          this.played = false;
        }
      });
    },
    loadVimeoPlayerSettings() {
      if (this.selectedVideoType == 1) return;

      const player = document.querySelector('#votd-vimeo');
      const play = false;
      const vm = this;

      this.vPlayer = new Vimeo.Player(player);

      this.vPlayer.on('play', () => {
        vm.processPlayedVideo();
      });

      this.vPlayer.on('ended', function () {
        vm.markAsCompleted();
      });
    },
    processPlayedVideo() {
      if (!this.played) {
        this.$http
          .post('/featured-video-played', {
            featuredVideoId: this.FeaturedVideo.id,
          })
          .then((response) => {
            this.played = true;
            parent.focus();
            this.$notify('success', 'Added to your played videos.');
          });
      } else {
      }
    },
    markAsCompleted() {
      this.isWatchedLoading = true;
      this.axios
        .post('/featured-video-watched', {
          featuredVideoId: this.FeaturedVideo.id,
        })
        .then(({ data }) => {
          this.isWatched = data.watched;
          this.isWatchedLoading = false;
          this.$notify('success', 'Added to your completed videos.');
        });
    },

    getIdFromVimeoURL(url) {
      let videoURL =
        /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})\?h=([a-zA-Z0-9]*)[?]?.*/.exec(
          url
        );

      if (videoURL == null) {
        videoURL =
          /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})\/?([a-zA-Z0-9]*)[?]?.*/.exec(
            url
          );
      }

      if (videoURL[6]) {
        return videoURL[5] + '?h=' + videoURL[6];
      }

      return videoURL[5];
    },

    youtubeParser(url) {
      const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      const youtubeId = match && match[7].length == 11 ? match[7] : false;

      return youtubeId;
    },
    fetchVideoId() {
      const url = this.videoUrl;

      if (this.debounce !== null) {
        clearTimeout(this.debounce);
      }

      const vm = this;
      this.debounce = setTimeout(() => {
        vm.loading = true;

        let youtubeId = vm.youtubeParser(url);

        if (url.includes('vimeo') || youtubeId != false) {
          if (youtubeId != false) {
            vm.youtube_id = youtubeId;
            vm.videoType = 1;
          } else {
            vm.youtube_id = vm.getIdFromVimeoURL(url);
            vm.videoType = 0;
          }
        } else {
          this.$notify('warning', 'Not a Vimeo URL or YouTube URL ');
          this.videoUrl = '';
          this.youtube_id = '';
        }
        vm.loading = false;
      }, 500);
    },
  },
  created() {
    this.getLatestVideo();
  },
};
</script>
<style lang="stylus" scoped>
.video-container{
  position: relative;
}
.votd-heading {
  font-family: Oswald;
}

.kt-portlet {
  border-radius: 0px;
}

.kt-portlet.votd-container {
  background: #e3e8ef;
}
.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {
    border: none !important;
    background: none !important;
    color: black !important;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin-bottom: 0;
}
</style>
